import { useTheme } from 'next-themes';
import { memo } from 'react';

import { PaletteIcon } from '@air/design-icons';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
} from '@air/primitive-dropdown-menu';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export const WorkspaceHeaderInformationDropdownThemeItems = memo(() => {
  const { theme, setTheme } = useTheme();
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <>
      {!ui2026 && <DropdownMenuSeparator />}
      <DropdownMenuSub
        label="Color theme"
        prefix={
          ui2026 ? (
            <PaletteIcon aria-hidden className="ads:text-icon-subtle text-gray-9" size="sm" />
          ) : (
            <PaletteIcon size="sm" />
          )
        }
        size="small"
      >
        <DropdownMenuRadioGroup value={theme} onValueChange={setTheme}>
          <DropdownMenuRadioItem label="Light" size="small" value="light" />
          <DropdownMenuRadioItem label="Dark" size="small" value="dark" />
          <DropdownMenuRadioItem label="System" size="small" value="system" />
        </DropdownMenuRadioGroup>
      </DropdownMenuSub>
    </>
  );
});

WorkspaceHeaderInformationDropdownThemeItems.displayName = 'WorkspaceHeaderInformationDropdownThemeItems';
